/*
 * @Author: hippo
 * @Date: 2023-06-14 09:22:25
 * @LastEditors: hippo
 * @LastEditTime: 2023-11-02 17:04:30
 * @FilePath: /subang-console/src/models/orders/defines/Order.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { Record, List, fromJS } from 'immutable';

export default class Order extends Record({
  _id: '',
  images: [],
  feedback_images: [],
  active_state: '',
  product: null,
  product_list: [],
  accessories_express: [],
  desc: '',
  assignTo: '',
  tenant: '',
  createdAt: '',
  createdBy: '',
  tenantAssignTo: '',
  order_no: '',
  order_number: '',
  order_tip_op: 0,
  payer_type: '',
  return_pay: '',
  pick_info: '',
  prev_order: null,
  receive_state: '',
  isPaid: '',
  order_type: '',
  address: '',
  addr_code: '',
  addr_detail: '',
  addr_location: null,
  service_time: '',
  fee: List(),
  fee_total: 0,
  fee_service: 0,
  worker_fee: List(),
  worker_fee_total: 0,
  worker: '',
  contact_name: '',
  contact_mobile: '',
  pay_method: '',
  payer_id: '',
  memo: List(),
  fee_locked: false,
  status_code: 1000,
  close_reason: '',
  closeBy: '',
  closeAt: '',
  tags: List(),
  worker_completed: false,
  worker_completed_at: '',
  platform_checked: false,
  platform_checked_at: '',
  tenant_checked: false,
  tenant_checked_at: '',
  worker_assigned_at: '',
  fee_locked_from: null,
  is_captcha: false,
  order_flag: 0,
  order_source: '',//店铺名称
  tech_mobile: '',//技术电话
  logistics_mobile: '', //物流电话
  feedback_demand: '', //反馈要求
  is_return: false,//是否返件
  return_address: '',//返件地址
  worker_deduction: null,
  tenant_deduction: null,
  appeal: null,
  accept_status: null,
  worker_services: null, //上门服务历史,
  workerFeePaid: false,
  reason: null, //上门原因,
  is_notify: false, //是否把师傅电话通知客户，
  tenant_cancel_status: null, //商家取消状态 0未申请 1申请中 2 客服同意 3客服拒绝
  tenant_cancel_reason: null, //商家取消原因
  coupon: null, //本订单使用的代金券
  bonus: null, //本订单使用的奖金券
  express: null, //快递信息,
  return_express: null,
  accessories: null, //工单配件
  custom_name: '', //客户姓名-new
  custom_phone: '', //客户联系方式-new
  is_urgent: false, //是否急单-new
  is_up: false, //是否上楼-new
  is_elevator: false, //有无电梯-new
  is_arrival: false, //到货状态-new
  is_pick: false, //是否提货-new
  is_retail: false, //是否散户-new
  floor: 0, //所在楼层-new
  technical_call: '',//技术电话-new
  last_reply: '', //最后回复时间-new
  is_fold: false, //是否折叠数据
  is_tip: false, //提醒消息
  is_guaqi: false, //挂起状态
  is_new: 0,//是否新工单
  gua_reason: '',//挂起原因
  tip: [],
  stag: 0,
  custom_lock_fee: false,
  tenant_confirm_fee: false,
  showEvaluate: false,
  ticket_type: 0,
  service_fee: 0,
  total_service_fee: 0,
  worker_fee_service: 0,
  quotationNum: 0,
  quotationMinPrice: null,
  convId: 0,
  tenant_refuse_fee_reason: '',
  appeal_history: [],
  tenant_deduction_history: [],
  remark: '',
  order_name: '',
  item_quantity: 0,
  expected_price: 0,
  orderInspection: null,
  workerResult: '',
  timeOut: '',
}) {
  constructor(props) {
    super(fromJS(props));
  }
}
